// src/Component/PaymentBadge.jsx
import React from 'react';

export const PaymentBadge = ({ userPayment, optionId, isPaid }) => {
  // If user has payment or it's an excluded item, don't render anything
  if (userPayment || ["bookmarkedquestions", "bookmarkedpdfs", "questionshistory", "subjectprogress"].includes(optionId)) {
    return null;
  }

  return (
    <span style={{
      position: 'absolute',
      top: '5px',
      right: '5px',
      padding: '4px 10px',
      borderRadius: '12px',
      fontSize: '10px',
      fontWeight: 'bold',
      backgroundColor: isPaid ? '#ffe0e0' : '#dff7e3',
      color: isPaid ? '#d60000' : '#087f23',
      zIndex: 2
    }}>
      {isPaid ? 'Paid' : 'Free'}
    </span>
  );
};